import React, { useMemo, useRef, useState, useEffect, useContext } from "react";
import { Image, Table, Form, Button } from "react-bootstrap";
import SelectReact from "./SelectReact";
import CheckValid from "./CheckValid";
import EmptySpaceFieldValid from "./EmptySpaceFieldValid";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDateTime from "./CommonDateTime";
import AmountNumberFormat from "./AmountNumberFormat";
import Logo from "../../assets/img/logo.svg";
import VirtualOrderWarehouseAssignAPI from "../../Api/VirtualOrderWarehouseAssignAPI";
import { WebSocketContext } from "../../App";
import wsSend_request from "../../Api/ws/ws_request";
import { FRANCHISE_DISPATCH_URL } from "../Shared/constant";

// CHANGE THIS IMPORT AS PER YOUR NEW API FILE
// import VirtualOrderWarehouseAssignAPI from "../../Api/VirtualOrderWarehouseAssignAPI";

export default function PurchaseOrderReport(props) {
  const {
    selfInfo,
    wareHouselistall,
    AllDispacchList,
    accessToken,
    device_id,
  } = useSelector((state) => state.adminReducers);

  const { OrderReportDetails, APIcalling } = props;
  const PendingForStores = useLocation()?.pathname?.split("/")[1];

  const isVirtualOrder = OrderReportDetails?.order?.is_virtual_order;
  const divRef = useRef(null);

  const [selectWarehouse, setselectWarehouse] = useState("");
  const [selectDispatch, setselectDispatch] = useState("");
  const [errorAddress, seterrorAddress] = useState("");
  const [errorSelectWarehouse, setErrorSelectWarehouse] = useState("");
  const [errorSelectDispatch, setErrorSelectDispatch] = useState("");
  const [warehouseDivHight, setwarehouseDivHight] = useState("");
  const [loading, setLoading] = useState(false);

  const optionsWarehouse = useMemo(() => {
    return wareHouselistall
      ?.filter((elm) => elm?.is_active === true)
      ?.map((item) => ({
        key: item?.id,
        value: item?.id,
        label: `${item?.warehouse_name} (${item?.warehouse_code}) - (${item?.display_name})`,
      }));
  }, [wareHouselistall]);

  const optionsDispatch = useMemo(() => {
    if (!selectWarehouse) return [];

    return (
      AllDispacchList?.filter((elm) => elm?.is_active === true)?.map(
        (item) => ({
          ...item,
          key: item?.id,
          value: item?.id,
          label: item?.dispatch_name,
        }),
      ) || []
    );
  }, [AllDispacchList, selectWarehouse]);

  useEffect(() => {
    if (divRef.current) {
      setwarehouseDivHight(divRef.current.clientHeight);
    }
  }, [isVirtualOrder]);

  const callDispatchList = (warehouse_id) => {
    if (websocket && warehouse_id) {
      const param = {
        transmit: "broadcast",
        url: "dispatch_list",
        request: {
          status: "",
          limit: 5000,
          page_no: 1,
          search: "",
          warehouse_id: warehouse_id,
        },
        DeviceId: device_id,
      };

      wsSend_request(websocket, param);
    }
  };

  const WareHouseSelect = (e) => {
    const value = e?.target?.value || "";

    setselectWarehouse(value);
    setselectDispatch("");

    if (value) {
      callDispatchList(value);
    }

    CheckValid(value, {
      type: "Select Warehouse",
      error: setErrorSelectWarehouse,
    });
  };
  const DispatchSelect = (e) => {
    const value = e?.target?.value || "";

    setselectDispatch(value);

    CheckValid(value, {
      type: "Select Dispatch",
      error: setErrorSelectDispatch,
    });
  };

  const Navigate = useNavigate();

  const VirtualOrderApproval = async () => {
    if (!selectWarehouse || !selectDispatch) {
      toast.error("Please fill all mandatory fields");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        order_id: OrderReportDetails?.order?.id,
        warehouse_id: selectWarehouse,
        dispatch_id: selectDispatch,
        warehouse_remark: "Reassigned due to stock availability",
      };

      const response = await VirtualOrderWarehouseAssignAPI(
        payload,
        accessToken,
      );

      if (response?.status !== 200) {
        toast.error(
          response?.message || response?.error || "Something went wrong",
        );
        return;
      }

      toast.success(response?.message || "Warehouse assigned successfully");
      Navigate(FRANCHISE_DISPATCH_URL);

      if (APIcalling) APIcalling();
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const { websocket } = useContext(WebSocketContext);

  const PermissionsAccess = selfInfo?.user?.permissions_access;

  return (
    <React.Fragment>
      {isVirtualOrder ? (
        <div
          className="Bigform_custom_scroll"
          style={{ height: "calc(100vh - 149px)" }}
        >
          <div
            className="filtr_Form"
            style={{ paddingBottom: "10px", borderBottom: "1px solid #eee" }}
          >
            <div className="formloginset formloginsetStaticData">
              <div className="row">
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Order No.</Form.Label>
                    <div className="defaultvalueField">
                      {OrderReportDetails?.order?.order_code}
                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Order Date</Form.Label>
                    <div className="defaultvalueField">
                      {CommonDateTime(
                        OrderReportDetails?.order?.created_at,
                        "LL",
                        "show",
                      )}
                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Franchise Name</Form.Label>
                    <div className="defaultvalueField">
                      {OrderReportDetails?.order?.billing?.customer_name ||
                        OrderReportDetails?.order?.customer_name}
                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Total Qty</Form.Label>
                    <div className="defaultvalueField">
                      {OrderReportDetails?.order?.qty}
                    </div>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Bill To</Form.Label>
                    <div className="defaultvalueFieldaddress">
                      <ul>
                        <li>
                          Name:{" "}
                          {OrderReportDetails?.order?.billing?.customer_name}
                        </li>
                        <li>
                          Address: {OrderReportDetails?.order?.billing?.address}
                        </li>
                        <li>
                          Mobile: {OrderReportDetails?.order?.billing?.mobile}
                        </li>
                        <li>
                          City:{" "}
                          {
                            OrderReportDetails?.order?.billing_pin_data
                              ?.district?.district_name
                          }
                        </li>
                        <li>
                          PIN Code:{" "}
                          {
                            OrderReportDetails?.order?.billing_pin_data
                              ?.pin_code?.pin_code
                          }
                        </li>
                        <li>
                          GST:{" "}
                          {OrderReportDetails?.order?.billing?.gst_no || "-"}
                        </li>
                      </ul>
                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>SHIP To</Form.Label>
                    <div className="defaultvalueFieldaddress">
                      <ul>
                        <li>
                          Name: {OrderReportDetails?.order?.customer_name}
                        </li>
                        <li>Address: {OrderReportDetails?.order?.address}</li>
                        <li>Mobile: {OrderReportDetails?.order?.mobile}</li>
                        <li>
                          City:{" "}
                          {OrderReportDetails?.order?.district?.district_name}
                        </li>
                        <li>
                          PIN Code:{" "}
                          {OrderReportDetails?.order?.pin_code?.pin_code}
                        </li>
                        <li>
                          GST: {OrderReportDetails?.order?.gstin_no || "-"}
                        </li>
                      </ul>
                    </div>
                  </Form.Group>
                </div>
              </div>
            </div>
          </div>

          <div className="tableView">
            <Table bordered>
              <thead>
                <tr>
                  <th>Sr. no</th>
                  <th>Product Code</th>
                  <th>Product Name</th>
                  <th>Unit Amount</th>
                  <th>Tax Amount</th>
                  <th>Quantity</th>
                  <th>Total Amount</th>
                </tr>
              </thead>

              <tbody>
                {OrderReportDetails?.order_items_list?.map((elm, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{elm?.hsn_code?.replace("PC", "")}</td>
                      <td>{elm?.product_name}</td>
                      <td>{AmountNumberFormat(elm?.price)}</td>
                      <td>{elm?.sub_gst}</td>
                      <td>{elm?.qty}</td>
                      <td>{AmountNumberFormat(elm?.sub_total)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <div className="tabsWrappers" style={{ maxWidth: "50%" }}>
              <div className="formloginset">
                <div className="row">
                  <div className="reassign_warehouse_wrapper">
                    <div className="col-md-12">
                      <Form.Group className="mb-3">
                        <Form.Label>Old Warehouse</Form.Label>
                        <div className="old_warehouse_details" ref={divRef}>
                          {OrderReportDetails?.order?.warehouse === undefined ||
                          OrderReportDetails?.order?.warehouse === null
                            ? "-"
                            : `${OrderReportDetails?.order?.warehouse?.warehouse_name} (${OrderReportDetails?.order?.warehouse?.display_name})`}
                        </div>
                      </Form.Group>
                    </div>

                    <div className="col-md-12">
                      <SelectReact
                        onChange={WareHouseSelect}
                        value={selectWarehouse}
                        options={optionsWarehouse?.filter(
                          (elm) =>
                            elm?.value !==
                            OrderReportDetails?.order?.warehouse?.id,
                        )}
                        isClearable
                        label={"Re-assign Warehouse"}
                        className="godown-select-container"
                        error={errorSelectWarehouse}
                        required
                        classNameForm={"mb-3"}
                      />
                    </div>

                    <div
                      className="border_right"
                      style={{
                        height: `calc(100% - 69px - ${warehouseDivHight}px)`,
                      }}
                    >
                      <i className="bi bi-caret-left-fill"></i>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <SelectReact
                      onChange={DispatchSelect}
                      value={selectDispatch}
                      options={optionsDispatch}
                      isClearable
                      label={"Select Dispatch"}
                      className="godown-select-container"
                      error={errorSelectDispatch}
                      required
                      classNameForm={"mb-3"}
                      disabled={!selectWarehouse}
                    />
                  </div>

                  <div
                    className="col-md-12 mb-3 reassign_btn_wrapper"
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      className="formbtn me-2"
                      onClick={VirtualOrderApproval}
                      id="approvlaMargin"
                      style={{ width: "auto" }}
                      variant="primary"
                      disabled={loading || !selectWarehouse || !selectDispatch}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : PendingForStores === "fba-orders-details" ? (
        <React.Fragment>
          <Table>
            <tbody>
              <tr>
                <td style={{ padding: "0px" }}>
                  <Image
                    src={
                      "data:image/svg+xml;base64,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"
                    }
                    alt={"Logo"}
                    className="h-auto"
                    width="120px"
                  />
                </td>
                <td style={{ padding: "0px", textAlign: "center" }}>
                  <Table>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "0px 0px 5px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                          colSpan={4}
                        >
                          Bill To - {OrderReportDetails?.order?.shipping_name}.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "0px 0px 5px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                          colSpan={4}
                        >
                          Address: {OrderReportDetails?.order?.bill_city} -{" "}
                          {OrderReportDetails?.order?.bill_pincode},{" "}
                          {OrderReportDetails?.order?.bill_state}, India.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "0px 0px 5px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                          colSpan={4}
                        >
                          Ship To - {OrderReportDetails?.order?.shipping_name}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "0px 0px 5px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                          colSpan={4}
                        >
                          Address: {OrderReportDetails?.order?.shipping_city} -{" "}
                          {OrderReportDetails?.order?.shipping_pincode},{" "}
                          {OrderReportDetails?.order?.shipping_state}, India.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                        >
                          Phone : {OrderReportDetails?.order?.bill_phone}
                        </td>
                        <td
                          style={{
                            padding: "0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                        >
                          EMail ID : {OrderReportDetails?.order?.bill_email}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </td>
              </tr>
              <tr>
                <th
                  style={{
                    padding: "17px 0px",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                  colSpan={2}
                >
                  SALES ORDER
                </th>
              </tr>
              <tr>
                <td style={{ padding: "0px", textAlign: "left" }} colSpan={2}>
                  <Table>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "7px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                        >
                          Order No :{" "}
                          {OrderReportDetails?.order?.display_order_code}
                        </td>
                        <td
                          style={{
                            padding: "7px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                            textAlign: "center",
                          }}
                        >
                          Order Date :{" "}
                          {CommonDateTime(
                            OrderReportDetails?.order?.created_at,
                            "LL",
                            "show",
                          )}
                        </td>
                        <td
                          style={{
                            padding: "7px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                            textAlign: "center",
                          }}
                        >
                          Invoice Date :{" "}
                          {CommonDateTime(
                            OrderReportDetails?.order?.invoice_at,
                            "LL",
                            "show",
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </td>
              </tr>
            </tbody>
          </Table>

          <Table className="printTable table-common" bordered>
            <thead>
              <tr>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Sl. No.
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Product Description
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  HSN Code
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  UOM
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Rate
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Qty
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Taxable Amount
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  State Gst Percentage
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Central Gst Percentage
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {OrderReportDetails?.order_items_list?.map((elm, index) => (
                <tr key={index}>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {index + 1}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.item_name}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.hsn_code}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.item_sku}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {AmountNumberFormat(elm?.selling_price)}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.qty}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {parseFloat(
                      elm?.selling_price_without_taxes_and_discount,
                    ).toFixed(2)}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.state_gst_percentage}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.central_gst_percentage}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {AmountNumberFormat(parseInt(elm?.total_price * elm?.qty))}
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={4}></td>
                <td
                  colSpan={OrderReportDetails?.order?.ntr === "Intra" ? 8 : 6}
                >
                  <span>
                    Status:{" "}
                    <b>
                      {OrderReportDetails?.order?.marketplace_status?.replace(
                        "_",
                        " ",
                      )}
                    </b>
                  </span>
                </td>
              </tr>
            </tbody>
          </Table>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Table>
            <tbody>
              <tr>
                <td style={{ padding: "0px" }}>
                  <Image src={Logo} style={{ width: "120px" }} alt="logo" />
                </td>
                <td style={{ padding: "0px", textAlign: "center" }}>
                  <Table>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "0px 0px 5px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                          colSpan={4}
                        >
                          Bill To - {OrderReportDetails?.order?.customer_name}.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "0px 0px 5px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                          colSpan={4}
                        >
                          Address: {OrderReportDetails?.order?.billing?.address}
                          ,{OrderReportDetails?.order?.billing?.address2}{" "}
                          {
                            OrderReportDetails?.order?.billing_pin_data
                              ?.district?.district_name
                          }{" "}
                          -{" "}
                          {
                            OrderReportDetails?.order?.billing_pin_data
                              ?.pin_code?.pin_code
                          }
                          ,{" "}
                          {
                            OrderReportDetails?.order?.billing_pin_data?.state
                              ?.state_name
                          }
                          , India.
                        </td>
                      </tr>
                      <tr>
                        <th
                          style={{
                            padding: "0px 0px 5px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                          colSpan={4}
                        >
                          {OrderReportDetails?.order?.customer_name}
                        </th>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "0px 0px 5px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                          colSpan={4}
                        >
                          Address: {OrderReportDetails?.order?.address},{" "}
                          {OrderReportDetails?.order?.district?.district_name} -{" "}
                          {OrderReportDetails?.order?.pin_code?.pin_code},{" "}
                          {OrderReportDetails?.order?.state?.state_name}, India.
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                        >
                          Phone : {OrderReportDetails?.order?.mobile}
                        </td>
                        <td
                          style={{
                            padding: "0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                        >
                          EMail ID : {OrderReportDetails?.order?.email}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </td>
              </tr>
              <tr>
                <th
                  style={{
                    padding: "17px 0px",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                  colSpan={2}
                >
                  SALES ORDER
                </th>
              </tr>
              <tr>
                <td style={{ padding: "0px", textAlign: "left" }} colSpan={2}>
                  <Table>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "7px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                        >
                          Franchise ID :{" "}
                          {OrderReportDetails?.order?.billing?.franchise_code?.replace(
                            "FC",
                            "",
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "7px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                          }}
                        >
                          Order No : {OrderReportDetails?.order?.order_code}
                        </td>
                        <td
                          style={{
                            padding: "7px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                            textAlign: "center",
                          }}
                        >
                          Order Date :{" "}
                          {CommonDateTime(
                            OrderReportDetails?.order?.created_at,
                            "LL",
                            "show",
                          )}
                        </td>
                        <td
                          style={{
                            padding: "7px 0px",
                            borderBottom: "0px",
                            fontSize: "14px",
                            textAlign: "center",
                          }}
                        >
                          Invoice Date :{" "}
                          {CommonDateTime(
                            OrderReportDetails?.order?.invoice_at,
                            "LL",
                            "show",
                          )}
                          {PendingForStores === "pending-for-stores" &&
                            selfInfo?.user?.user_type === "super_admin" && (
                              <a
                                href="/erp-stock-level"
                                className="sotklevelbtn"
                                target="__blank"
                              >
                                Stock Level
                              </a>
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </td>
              </tr>
            </tbody>
          </Table>

          <Table className="printTable table-common" bordered>
            <thead>
              <tr>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Sl. No.
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Product Description
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  HSN Code
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  UOM
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Rate
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Qty
                </th>
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Taxable Amount
                </th>
                {OrderReportDetails?.order?.ntr === "Intra" ? (
                  <React.Fragment>
                    <th
                      style={{
                        padding: "0px",
                        borderBottom: "0px",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      colSpan={2}
                    >
                      SGST
                      <Table
                        bordered
                        style={{ margin: "0px", textAlign: "center" }}
                      >
                        <tbody>
                          <tr>
                            <th
                              style={{
                                padding: "7px 7px",
                                borderBottom: "0px",
                                fontSize: "14px",
                              }}
                            >
                              Rate
                            </th>
                            <th
                              style={{
                                padding: "7px 7px",
                                borderBottom: "0px",
                                fontSize: "14px",
                              }}
                            >
                              Amount
                            </th>
                          </tr>
                        </tbody>
                      </Table>
                    </th>
                    <th
                      style={{
                        padding: "0px",
                        borderBottom: "0px",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      colSpan={2}
                    >
                      CGST
                      <Table
                        bordered
                        style={{ margin: "0px", textAlign: "center" }}
                      >
                        <tbody>
                          <tr>
                            <th
                              style={{
                                padding: "7px 7px",
                                borderBottom: "0px",
                                fontSize: "14px",
                              }}
                            >
                              Rate
                            </th>
                            <th
                              style={{
                                padding: "7px 7px",
                                borderBottom: "0px",
                                fontSize: "14px",
                              }}
                            >
                              Amount
                            </th>
                          </tr>
                        </tbody>
                      </Table>
                    </th>
                  </React.Fragment>
                ) : (
                  <th
                    style={{
                      padding: "0px",
                      borderBottom: "0px",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                    colSpan={2}
                  >
                    IGST
                    <Table
                      bordered
                      style={{ margin: "0px", textAlign: "center" }}
                    >
                      <tbody>
                        <tr>
                          <th
                            style={{
                              padding: "7px 7px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            Rate
                          </th>
                          <th
                            style={{
                              padding: "7px 7px",
                              borderBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </tbody>
                    </Table>
                  </th>
                )}
                <th
                  style={{
                    padding: "7px 7px",
                    borderBottom: "0px",
                    fontSize: "14px",
                  }}
                >
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {OrderReportDetails?.order_items_list?.map((elm, index) => (
                <tr key={index}>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {index + 1}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.product_name}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.hsn_code}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.sku_type}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {AmountNumberFormat(elm?.price)}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {elm?.qty}
                  </td>
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {parseFloat(elm?.sub_total - elm?.sub_gst).toFixed(2)}
                  </td>
                  {OrderReportDetails?.order?.ntr === "Intra" ? (
                    <React.Fragment>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {parseFloat(elm?.sgst_rate).toFixed(2)}%
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {elm?.sub_sgst}
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {parseFloat(elm?.cgst_rate).toFixed(2)}%
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {elm?.sub_cgst}
                      </td>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {parseFloat(elm?.gst_rate).toFixed(2)}%
                      </td>
                      <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                        {elm?.sub_gst}
                      </td>
                    </React.Fragment>
                  )}
                  <td style={{ padding: "7px 7px", fontSize: "14px" }}>
                    {AmountNumberFormat(parseInt(elm?.sub_total))}
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={4}></td>
                <td
                  colSpan={OrderReportDetails?.order?.ntr === "Intra" ? 8 : 6}
                >
                  <span>
                    Status:{" "}
                    <b>
                      {OrderReportDetails?.order?.order_status?.replace(
                        "_",
                        " ",
                      )}
                    </b>
                  </span>
                </td>
              </tr>
            </tbody>
          </Table>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
